import React from 'react';
import { Action } from '../models/Action';
import { ToggleSwitch } from './ToggleSwitch';
import { Visibility } from '../models/APIModels';
import { Clear, Edit, Delete  } from '@mui/icons-material';

interface IProps {
  actions: Action[];
  item: any;
  onActionButtonClick: (event, type, item: any, context?: any) => void;
  context?: any;
}
const ActionColumn = ({ actions, item, onActionButtonClick, context }: IProps) => {
  return (
    <div>
      {actions &&
        actions.length > 0 &&
        actions.map((a, i) => {
          return (
            <span key={a.type} data-key={a.type} className={a.className} style={{ marginRight: '10px' }}>
              {!['ToggleButton','Edit', 'Delete', 'Reject'].includes(a.component)  && (
                <span className="" onClick={(e) => onActionButtonClick(e, a.type, item, context)}>
                  {a.component}
                </span>
              )}
               {a.component === 'ToggleButton' && (
                <ToggleSwitch
                  label={a.title}
                  marginTop={0}
                  value={item.visibility === Visibility.Public}
                  change={(event) => onActionButtonClick(event, a.type, item, context)}
                />
              )}
              {a.component === "Edit" && (
                
                <span className="admin_model_icon"  title="Edit" onClick={(e) => onActionButtonClick(e, a.type, item, context)}>
                <Edit fontSize="small" />
              </span>
              )}
              {a.component === "Delete" && (
                
                <span className="admin_model_icon"  title="Delete" onClick={(e) => onActionButtonClick(e, a.type, item, context)}>
                <Delete fontSize="small"/>
              </span>
              )}
              {a.component === "Reject" && (
                
                <span  className="admin_model_icon" title="Reject" onClick={(e) => onActionButtonClick(e, a.type, item, context)}>
                <Clear fontSize="small"/>
              </span>
              )}
            </span>
          );
        })}
    </div>
  );
};

export default ActionColumn;
